import {
  SET_CALENDAR_SHEET,
  SET_WORKERS,
  SET_CALENDAR_DATA,
  SET_VIEW,
  SET_TASKS_MODAL_VISIBLE,
  SET_TASKS_MODAL_DATA,
  SET_MODE,
  SET_STATE,
  SET_LOCAL_TASK,
  SET_INFO_MODAL_VISIBLE,
  SET_CHANGEABLE_TASK_STATUS,
  SET_INNER_ACTIVATION_OF_CHANGE,
  TOGGLE_OWNER,
} from './actionTypes';

export const setCalendarSheet = (payload) => ({
  type: SET_CALENDAR_SHEET,
  payload,
});

export const setWorkers = (payload) => ({
  type: SET_WORKERS,
  payload,
});

export const setCalendarData = (payload) => ({
  type: SET_CALENDAR_DATA,
  payload,
});

export const setView = (payload) => ({
  type: SET_VIEW,
  payload,
});

export const setTasksModalVisible = (payload) => ({
  type: SET_TASKS_MODAL_VISIBLE,
  payload,
});

export const setTasksModalData = (payload) => ({
  type: SET_TASKS_MODAL_DATA,
  payload,
});

export const setMode = (payload) => ({
  type: SET_MODE,
  payload,
});

export const setCalendarState = (payload) => ({
  type: SET_STATE,
  payload,
});

export const setLocalTask = (payload) => ({
  type: SET_LOCAL_TASK,
  payload,
});

export const setInfoModalVisible = (payload) => ({
  type: SET_INFO_MODAL_VISIBLE,
  payload,
});

export const setChangeableTaskStatus = (payload) => ({
  type: SET_CHANGEABLE_TASK_STATUS,
  payload,
});

export const setInnerActivationOfChange = (payload) => ({
  type: SET_INNER_ACTIVATION_OF_CHANGE,
  payload,
});

export const toggleOwner = () => ({
  type: TOGGLE_OWNER,
});
